import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-mat-tab',
  templateUrl: './mat-tab.component.html',
  styleUrls: ['./mat-tab.component.scss']
})
export class MatTabComponent implements OnInit {

  @Input('tabTitle') displayTitle
  @Input('index') titleIndex
  @Input('indexSelected') selected
  @Input('matId') documentId
  @Output() tabEvent: EventEmitter<any> = new EventEmitter<any>();
  matTitle
  indexId
  selectedIndex



  constructor() { }

  ngOnInit() {
    console.log("matID",this.documentId,"indexSelected",this.selected);
    
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("display mat tab first time", changes);
    if (changes.displayTitle && changes.displayTitle.currentValue) {
      this.matTitle = changes.displayTitle.currentValue
    }

    if (changes.documentId && changes.documentId.currentValue) {
      this.indexId = changes.documentId.currentValue
    }

    if (changes.selected && changes.selected.currentValue) {
      this.selectedIndex = changes.selected.currentValue
    }

  }


  changeTabEvent() {
    this.tabEvent.emit(this.matTitle)
    // this.selectedIndex = -1
  }


}
